import React from "react";
import "./FlareStackFlame.css";

function FlareStackFlame({
  FIC_2985,
  FIC_2981,
  FIC_2983,
  isXV2983Open,
  isXV2982Open,
  x = 500,
  y = 100
}) {

  // ================= PILOT FLAME 1 =================
  const showPilot1 =
    isXV2983Open && FIC_2985 > 0;

  // ================= PILOT FLAME 2 =================
  const showPilot2 =
    isXV2982Open && FIC_2981 > 0;

  // ================= MAIN FLAME LEVEL =================
  let flameLevel = 0;

  if (FIC_2983 >= 1 && FIC_2983 < 5) flameLevel = 1;
  else if (FIC_2983 >= 5 && FIC_2983 < 10) flameLevel = 2;
  else if (FIC_2983 >= 10 && FIC_2983 < 15) flameLevel = 3;
  else if (FIC_2983 >= 20 && FIC_2983 < 25) flameLevel = 4;
  else if (FIC_2983 >= 25) flameLevel = 5;

  return (
    <div
      className="flare-container"
      style={{ left: x, top: y }}
    >
      <svg width="120" height="220" viewBox="0 0 120 220">

        {/* ================= PILOT SMALL ================= */}
        {showPilot1 && (
          <path
            className="flame pilot-small"
            d="M60 200 Q58 180 60 160 Q62 180 60 200"
          />
        )}

        {/* ================= PILOT LARGE ================= */}
        {showPilot2 && (
          <path
            className="flame pilot-large"
            d="M60 200 Q50 160 60 120 Q70 160 60 200"
          />
        )}

        {/* ================= MAIN FLAME ================= */}

        {flameLevel >= 1 && (
          <path
            className="flame main level1"
            d="M60 200 Q45 140 60 100 Q75 140 60 200"
          />
        )}

        {flameLevel >= 2 && (
          <path
            className="flame main level2"
            d="M60 200 Q40 120 60 80 Q80 120 60 200"
          />
        )}

        {flameLevel >= 3 && (
          <path
            className="flame main level3"
            d="M60 200 Q35 100 60 60 Q85 100 60 200"
          />
        )}

        {flameLevel >= 4 && (
          <path
            className="flame main level4"
            d="M60 200 Q30 80 60 40 Q90 80 60 200"
          />
        )}

        {flameLevel >= 5 && (
          <path
            className="flame main level5"
            d="M60 200 Q20 100 100 50 Q100 120 60 200"
          />
        )}

      </svg>
    </div>
  );
}

export default FlareStackFlame;